import request from '@/router/axios';

// 我的申请列表
export const getMyList = (pageNumber,pageSize) => request({
  url: '/api/blade-remote/manySubject/myApplyList',
  method: 'get',
  params:{
    current:pageNumber,
    size:pageSize
  }

})
// 与我相关列表
export const getToMeList = (pageNumber,pageSize) => request({
  url: '/api/blade-remote/manySubject/applyListToMe',
  method: 'get',
  params:{
    current:pageNumber,
    size:pageSize
  }
})
